var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mibile-wrapper"},[_c('Home-Header',{attrs:{"navindex":4}}),_vm._v(" "),_c('Home-TabBar',{attrs:{"navindex":0}}),_vm._v(" "),_c('Home-Content'),_vm._v(" "),_c('a',{attrs:{"id":"newBridge-mobile","href":"http://pkt.zoosnet.net/LR/Chatpre.aspx?id=PKT58642380&lng=cn","rel":"nofollow","target":"_blank"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dcfc358","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mhome/MTechnology.vue
// module id = null
// module chunks = 